<template>
	<div class="content-pad-vert content-pad-horizontal">
		<v-layout row wrap class="pt-3">
			<v-flex xs12 sm10 offset-sm1>
				<p class="event-search__filters">{{ searchResultsLabel }}</p>
			</v-flex>
			<v-flex
				xs12
				sm6 offset-sm1
				md7 offset-md1
				lg7 offset-lg1
				xl7 offset-xl1
			>
				<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;">
					<div 
						v-if="!getEventsLoaded"
						class="event-search__event-tile-flex mt-5"
					>
						<v-progress-circular indeterminate size="100" color="grey darken-5"></v-progress-circular>
					</div>
					<div v-else-if="getFilteredEvents.length === 0">
						Sorry, there are no events matching these filters
					</div>
					<div
						v-else
						v-for="event in getFilteredEvents"
						class="event-search__event-tile-flex"
						:id="'event-search-event-'+event.pk"
						:key="event.pk"
						style="min-height: 200px;"
					>
						<event-list-item :event="event"></event-list-item>
					</div>
				</div>
				<div style="width:100%" class="text-xs-center">
					<div class="event-search__card-divider mt-5 mb-5">
					</div>
					<div style="padding: 0 15%;" class="text-xs-center">
						<p class="event-search__content-light">Not finding a WRKPRTY close enough to you?</p>
						<div v-if="userIsHost">
							<p class="event-search__content-light"><router-link :to="{ name: 'host_add_event_intro' }">Host a WRKPRTY!</router-link></p>
						</div>
						<div v-else>
							<p class="event-search__content-light"><router-link :to="{ name: 'host_info' }"><b>Become a host</b></router-link> and start your own at your home, or a location nearby!</p>
							<p class="event-search__content-light">It's people just like you, looking to connect and build community, that are becoming hosts everyday.</p>
							<p class="event-search__content-light"><router-link :to="{ name: 'host_info' }"><b>Join us! Become a WRKPRTY Host!</b></router-link></p>
						</div>
					</div>
				</div>
			</v-flex>
			<v-flex xs12 sm4 md3 lg3 xl3 class="hidden-xs-only">
				<div class="date-picker">
					<v-date-picker
						full-width
						no-title
						v-model="selectedDate"
						:event-color="getCalendarDateColor"
						:events="allowedDates"
						reactive
						:picker-date="firstEventDate"
						v-on:update:pickerDate="updateFirstEventDate"
						color="link"
						id="date-picker-1"
						class="filter-card"
					></v-date-picker>
					<v-btn block v-if="getEventFilters.date !== null" class="btn-blue ma-0" @click="setEventFilter({prop: 'date', value: null})">Clear Date Filter</v-btn>
				</div>
			</v-flex>

		</v-layout>
		<v-dialog v-model="dateDialog">
			<v-card>
				<v-date-picker
					full-width
					no-title
					v-model="selectedDate"
					:event-color="getCalendarDateColor"
					:events="allowedDates"
					id="date-picker-2"
					color="link"
				></v-date-picker>
				<v-btn block v-if="getEventFilters.date !== null" class="btn-blue ma-0" @click="setEventFilter({prop: 'date', value: null})">Clear Date Filter</v-btn>
			</v-card>
		</v-dialog>
		<v-btn dark fab fixed color="link" class="mobile-info-button hidden-sm-and-up" @click.stop="dateDialog = true"><v-icon medium color="grey lighten-2">fal fa-calendar-alt</v-icon></v-btn>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
	fetchAllEvents,
} from '~/store/api/event_location_api'
import {parse, format} from 'date-fns'
import EventList from '~/components/EventList.vue'
import EventListItem from '~/components/EventListItem.vue'

export default {
	name: 'event-search',
	data() {
		return {
			dateDialog: false,
			locationFilterDialog: false,
			thing: false,
			firstEventDate: '',
			firstEvent: { date: null },
			mapcenter: {
				lat: 0.0,
				lon: 0.0
			},
			radius: 20,
			categories: [
				{ title: 'All Categories', value: null },
				{ title: 'Wrkprty Original', value: 'classic' },
				{ title: 'Wrkprty Presents', value: 'presents' },
				{ title: 'Wrkprty Nightowl', value: 'night' },
				{ title: 'Wrkprty Weekend', value: 'weekend' }
			],
			distances: [
				{ title: '1 mile', value: 1 },
				{ title: '5 miles', value: 5 },
				{ title: '10 miles', value: 10 },
				{ title: '20 miles', value: 20 },
				{ title: '50 miles', value: 50 }
			],
			currentDistance: '50 miles',
			popularCities: ['Los Angeles', 'San Fransisco', 'New York', 'Chicago'],
			min_price: null,
			max_price: null,
			// selectedDate: null,
			selectedCategory: null,
			dateLabelColor: '',
			categoryLabelColor: '',
			priceLabelColor: '',
			location: null
		}
	},
	created() {
		fetchAllEvents().then((response) => {
			this.setAllEvents(response.data)
			if (response.data.length > 0) {
				this.firstEvent = response.data[0]
				this.updateFirstEventDate(response.data[0].date)
			}
			this.setEventsLoaded(true)
		}).catch((error) => {
			console.error(error)
		})
		this.setMobileNavActive('events')
		window.addEventListener('scroll', this.handleScroll)

		this.setEventFilter({
			prop: 'date',
			value: null
		})
	},
	methods: {
		...mapActions([
			'setMobileNavActive',
			'setEventsLoaded',
			'setAllEvents',
			'fetchNearbyEvents',
			'setEventFilter'
		]),
		updateFirstEventDate(value) {
			this.firstEventDate = value
		},
		handleScroll() {
			let e = document.getElementById(
				'event-search-event-' + this.firstEvent.pk
			)
			let firstEventHeight = -9999
			if (e) {
				firstEventHeight = e.getBoundingClientRect().top
			}
			let tempFirstEvent = null
			let tempEl = null
			let tempHeight = null
			for (var i = 0; i < this.getFilteredEvents.length; i++) {
				e = document.getElementById(
					'event-search-event-' + this.getFilteredEvents[i].pk
				)
				if (e) {
					tempHeight = e.getBoundingClientRect().top
					if (firstEventHeight < 0) {
						if (tempHeight > 0) {
							firstEventHeight = tempHeight
							tempFirstEvent = this.getFilteredEvents[i]
						}
					}
					if (tempHeight < firstEventHeight && tempHeight > 0) {
						tempFirstEvent = this.getFilteredEvents[i]
						firstEventHeight = tempHeight
					}
				}
			}
			if (tempFirstEvent !== null) {
				this.firstEvent = tempFirstEvent
				this.firstEventDate = tempFirstEvent.date
			}
		},
		getCalendarDateColor(date) {
			let objs = this.getAllEvents.filter(e => e.date === date)
			let obj = objs.find(obj => obj.host.user.pk === this.user.pk)
			return obj ? 'success' : 'info'
		},
		setPlace(place) {
			this.mapcenter = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng()
			}
			this.search()
		},
		search() {
			let locationString = this.mapcenter.lat + ',' + this.mapcenter.lng
			this.fetchNearbyEvents({ location: locationString, radius: this.radius })
		},
		selectCategory(item) {
			this.selectedCategory = item.value
		},
		changeLocationFilter() {
			this.locationFilterDialog = true
		},
		allowedDates(date) {
			for (var j = 0; j < this.getAllEvents.length; j++) {
				if (this.getAllEvents[j].date === date) {
					return true
				}
			}
			return false
		}
	},
	watch: {
		min_price() {
			if (this.min_price !== null) {
				this.setEventFilter({ prop: 'min_price', value: this.min_price })
			}
		},
		max_price() {
			if (this.max_price !== null) {
				this.setEventFilter({ prop: 'max_price', value: this.max_price })
			}
		},
		selectedCategory() {
			if (this.selectedCategory !== null) {
				this.setEventFilter({ prop: 'category', value: this.selectedCategory })
			}
		},
		dateFilter() {
			if (this.getEventFilters.date === null) {
				this.selectedDate = null
			}
			return null
		},
		minPriceFilter() {
			if (this.getEventFilters.min_price === null) {
				this.min_price = null
			}
		},
		maxPriceFilter() {
			if (this.getEventFilters.max_price === null) {
				this.max_price = null
			}
		},
		categoryFilter() {
			if (this.getEventFilters.category === null) {
				this.selectedCategory = null
			}
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getAllEvents',
			'getEventsLoaded',
			'getEventFilters',
			'getFilteredEvents',
			'userIsHost',
			'getVisitorLocation'
		]),
		searchResultsLabel () {
			let date = parse(this.selectedDate)//, 'yyyy-MM-dd', new Date())
			if (this.getEventFilters.date) {
				return `Showing events on ${format(date, 'dddd MMM Do')}`
			} else {
				return 'ALL EVENTS & EXPERIENCES'
		//		return 'Showing events for all locations'

			}
		},
		selectedDate: {
			get() {
				return this.getEventFilters.date
			},
			set(val) {
				this.dateDialog = false
				this.setEventFilter({
					prop: 'date',
					value: val
				})
			}
		}
	},
	components: {
		EventList,
		EventListItem
	}
}
</script>

<style lang="scss" scoped>
.event-search__filters {
	font-family: 'Quantico';
	font-size: 1.1em;
	color: #777;
}
.date-picker {
	margin-left: 8% !important;
	position: -webkit-sticky;
	position: sticky;
	top: 86px;
}
.dashboard-filters {
	background-color: #fafafa;
	position: fixed;
	width: 100%;
	z-index: 2;
	border-bottom: 1px solid lightgray;
}
.search-box {
	height: 37px;
}
.search-icon {
	position: absolute;
	bottom: 13px;
	left: 17px;
	z-index: 1;
}
.filterButtonOff {
	color: black;
	border: 1px solid gray;
}
.filter-card {
	/*position: sticky;*/
	width: 100%;
}
.date-filter-button {
	bottom: 20px;
}

.event-search__content-light {
	margin-bottom: 7px;
	font-size: 0.8em;
	color: #888;
}

.event-search__card-divider {
	border-style: solid;
	border-width: 0px 0px 2px 0px;
	border-color: #ccc;
	width: 60%;
	margin-left: 20%;
}

.event-search__event-tile-flex {
	width: 48%;
	height: auto;
	margin-bottom: 60px;
}

/* sm */
@media screen and (max-width: 1200px) {
	.event-search__event-tile-flex {
		width: 100%;
	}
}

/* xs */
@media screen and (max-width: 599px) {
	.event-search__event-tile-flex {
		width: 100%;
		height: auto;
	}
}
</style>
